import React, { useState } from "react";
import { CUSTOM_ICONS } from "./customBrandIcons";

/**
 * Renders a brand icon WITHOUT a background tile container.
 *
 * Priority order:
 *   1. customIcon as URL/data-URI  -> render as <img object-contain>
 *   2. customIcon as registry key  -> render inline SVG component
 *   3. simpleicons CDN via slug    -> remote brand icon in brand color
 *   4. Fallback: first letter of the brand name
 */
export default function BrandIcon({
  slug,
  customIcon,
  color,
  iconColor,
  name,
  size = 44,
}) {
  const [error, setError] = useState(false);
  const px = `${size}px`;
  const innerSize = Math.round(size * 0.85);

  const isCustomUrl =
    typeof customIcon === "string" &&
    (customIcon.startsWith("http") || customIcon.startsWith("data:") || customIcon.startsWith("/"));

  const CustomComp = !isCustomUrl && customIcon ? CUSTOM_ICONS[customIcon] : null;

  // For simpleicons fallbacks, use the brand color (strip the leading #) so
  // the logo carries its own identity color instead of a generic white.
  const simpleIconColor = iconColor || (color || "ffffff").replace("#", "") || "ffffff";

  return (
    <div
      className="flex items-center justify-center shrink-0"
      style={{ width: px, height: px }}
    >
      {isCustomUrl && !error ? (
        <img
          src={customIcon}
          alt={name}
          onError={() => setError(true)}
          loading="lazy"
          className="max-w-full max-h-full object-contain"
        />
      ) : CustomComp ? (
        <CustomComp width={innerSize} height={innerSize} style={{ color: color || "#ffffff" }} />
      ) : !error && slug ? (
        <img
          src={`https://cdn.simpleicons.org/${slug}/${simpleIconColor}`}
          alt={name || slug}
          width={innerSize}
          height={innerSize}
          onError={() => setError(true)}
          loading="lazy"
        />
      ) : (
        <span
          className="font-bold"
          style={{
            color: color || "#ffffff",
            fontSize: Math.round(size * 0.5),
          }}
        >
          {(name || slug)?.[0]?.toUpperCase()}
        </span>
      )}
    </div>
  );
}
